import { render, staticRenderFns } from "./AGPFiles.vue?vue&type=template&id=82935b12&scoped=true"
import script from "./AGPFiles.vue?vue&type=script&lang=js"
export * from "./AGPFiles.vue?vue&type=script&lang=js"
import style0 from "./AGPFiles.vue?vue&type=style&index=0&id=82935b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82935b12",
  null
  
)

export default component.exports